import { WHATSAPP_CHANNEL_GET } from "../constant/ActionType";

export default function AllWhatsappChannnel(
  state = {
    allwhatsappchannel: [],
    statusCode: null,
  },
  action
) {
  switch (action.type) {
    case WHATSAPP_CHANNEL_GET:
      return {
        ...state,
        allwhatsappchannel: action.data,
        statusCode: action.status,
      };

    default:
  }

  return state;
}
